import { ON_STOP_GAME } from '../state-constants/stateConstants';

export const onStopGame = (bool) => ({
  type: ON_STOP_GAME,
  payload: bool,
});



// WEBPACK FOOTER //
// ./src/state-actions/onStopGame.js